import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { SavedJobsProvider } from './context/SavedJobsContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Chatbot from './components/Chatbot';
import Home from './pages/Home';
import Jobs from './pages/Jobs';
import JobDetail from './pages/JobDetail';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Education from './pages/Education';
import Survey from './pages/Survey';
import PostJob from './pages/PostJob';
import ManageJobScreening from './pages/ManageJobScreening';
import About from './pages/About';
import FAQs from './pages/FAQs';
import Terms from './pages/Terms';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Services from './pages/Services';
import './App.css';
import EmployerDashboard from './pages/EmployerDashboard';
import SavedJobs from './pages/SavedJobs';
import Profile from './pages/Profile';

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
      <SavedJobsProvider>
      <Router>
        <div className="flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/services" element={<Services />} />
              <Route path="/jobs" element={<Jobs />} />
              <Route path="/jobs/:id" element={<JobDetail />} />
              <Route path="/saved" element={<SavedJobs />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/employer-dashboard" element={<EmployerDashboard />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/education" element={<Education />} />
              <Route path="/survey" element={<Survey />} />
              <Route path="/post-job" element={<PostJob />} />
              <Route path="/jobs/:jobId/screening" element={<ManageJobScreening />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
          <Chatbot />
        </div>
      </Router>
      </SavedJobsProvider>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
